export const APP_STORE_URL =
  "https://apps.apple.com/us/app/careem-rides-food-delivery/id592978487";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.careem.acma&hl=en&gl=US";
